/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g clipPath="url(#clip0_2004_1784)">
				<path
					opacity="0.4"
					d="M8 7L9.13783 4.72433C10.059 2.88191 10.5197 1.96069 11.1429 1.66508C11.6854 1.40782 12.3146 1.40782 12.857 1.66508C13.4803 1.96069 13.941 2.88191 14.8622 4.72433L17.5 10"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 7L4.01929 14.9614C2.52082 17.9584 1.77158 19.4568 2.02258 20.2346C2.23924 20.9059 2.79354 21.4135 3.48131 21.5703C4.2781 21.7519 5.70492 20.8739 8.55857 19.1178L10.3229 18.0321C10.9318 17.6573 11.2363 17.47 11.5622 17.3969C11.8505 17.3322 12.1495 17.3322 12.4378 17.3969C12.7637 17.47 13.0682 17.6573 13.6771 18.0321L15.4414 19.1178C18.2951 20.8739 19.7219 21.7519 20.5187 21.5703C21.2065 21.4134 21.7608 20.9059 21.9774 20.2346C22.2284 19.4568 21.4792 17.9584 19.9807 14.9614L17.5 10"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1784">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g clipPath="url(#clip0_2004_1787)">
				<path
					opacity="0.12"
					d="M14.8622 4.72433C13.941 2.88191 13.4803 1.96069 12.857 1.66508C12.3146 1.40782 11.6854 1.40782 11.1429 1.66508C10.5197 1.96069 10.059 2.8819 9.13783 4.72433L4.01929 14.9614C2.52082 17.9584 1.77158 19.4568 2.02258 20.2346C2.23924 20.9059 2.79354 21.4134 3.48131 21.5703C4.2781 21.7519 5.70492 20.8739 8.55857 19.1178L10.3229 18.0321C10.9318 17.6573 11.2363 17.47 11.5622 17.3969C11.8505 17.3322 12.1495 17.3322 12.4378 17.3969C12.7637 17.47 13.0682 17.6573 13.6771 18.0321L15.4414 19.1178C18.2951 20.8739 19.7219 21.7519 20.5187 21.5703C21.2065 21.4134 21.7608 20.9059 21.9774 20.2346C22.2284 19.4568 21.4792 17.9584 19.9807 14.9614L14.8622 4.72433Z"
					fill="currentColor"
				/>
				<path
					d="M14.8622 4.72433C13.941 2.88191 13.4803 1.96069 12.857 1.66508C12.3146 1.40782 11.6854 1.40782 11.1429 1.66508C10.5197 1.96069 10.059 2.8819 9.13783 4.72433L4.01929 14.9614C2.52082 17.9584 1.77158 19.4568 2.02258 20.2346C2.23924 20.9059 2.79354 21.4134 3.48131 21.5703C4.2781 21.7519 5.70492 20.8739 8.55857 19.1178L10.3229 18.0321C10.9318 17.6573 11.2363 17.47 11.5622 17.3969C11.8505 17.3322 12.1495 17.3322 12.4378 17.3969C12.7637 17.47 13.0682 17.6573 13.6771 18.0321L15.4414 19.1178C18.2951 20.8739 19.7219 21.7519 20.5187 21.5703C21.2065 21.4134 21.7608 20.9059 21.9774 20.2346C22.2284 19.4568 21.4792 17.9584 19.9807 14.9614L14.8622 4.72433Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1787">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_1793)">
				<path
					d="M15.5778 4.47817C14.4262 2.17514 13.8505 1.02362 13.0714 0.654099C12.3933 0.332532 11.6067 0.332532 10.9287 0.654099C10.1496 1.02362 9.57386 2.17514 8.42234 4.47817L3.42695 14.469C1.55385 18.2151 0.617304 20.0882 0.931059 21.0604C1.20188 21.8996 1.89475 22.534 2.75447 22.73C3.75046 22.9571 5.53399 21.8596 9.10105 19.6644L9.90366 19.1705C10.6648 18.7021 11.0454 18.4679 11.4529 18.3765C11.8132 18.2957 12.1869 18.2957 12.5472 18.3765C12.9547 18.4679 13.3353 18.7021 14.0964 19.1705L14.899 19.6644C18.4661 21.8596 20.2496 22.9571 21.2456 22.73C22.1053 22.534 22.7982 21.8996 23.069 21.0604C23.3828 20.0882 22.4462 18.2151 20.5732 14.469L15.5778 4.47817Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1793">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<g clipPath="url(#clip0_2004_1782)">
				<path
					d="M17 9L14.8622 4.72433C13.941 2.88191 13.4803 1.96069 12.857 1.66508C12.3146 1.40782 11.6854 1.40782 11.1429 1.66508C10.5197 1.96069 10.059 2.8819 9.13783 4.72433L4.01929 14.9614C2.52082 17.9584 1.77158 19.4568 2.02258 20.2346C2.23924 20.9059 2.79354 21.4134 3.48131 21.5703C4.2781 21.7519 5.70492 20.8739 8.55857 19.1178L10.3229 18.0321C10.9318 17.6573 11.2363 17.47 11.5622 17.3969C11.8505 17.3322 12.1495 17.3322 12.4378 17.3969C12.7637 17.47 13.0682 17.6573 13.6771 18.0321L15.4414 19.1178C18.2951 20.8739 19.7219 21.7519 20.5187 21.5703C21.2065 21.4134 21.7608 20.9059 21.9774 20.2346C22.2284 19.4568 21.4792 17.9584 19.9807 14.9614L19 13"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1782">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<g clipPath="url(#clip0_2004_1780)">
				<path
					d="M14.8622 4.72433C13.941 2.88191 13.4803 1.96069 12.857 1.66508C12.3146 1.40782 11.6854 1.40782 11.1429 1.66508C10.5197 1.96069 10.059 2.8819 9.13783 4.72433L4.01929 14.9614C2.52082 17.9584 1.77158 19.4568 2.02258 20.2346C2.23924 20.9059 2.79354 21.4134 3.48131 21.5703C4.2781 21.7519 5.70492 20.8739 8.55857 19.1178L10.3229 18.0321C10.9318 17.6573 11.2363 17.47 11.5622 17.3969C11.8505 17.3322 12.1495 17.3322 12.4378 17.3969C12.7637 17.47 13.0682 17.6573 13.6771 18.0321L15.4414 19.1178C18.2951 20.8739 19.7219 21.7519 20.5187 21.5703C21.2065 21.4134 21.7608 20.9059 21.9774 20.2346C22.2284 19.4568 21.4792 17.9584 19.9807 14.9614L14.8622 4.72433Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1780">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_1790)">
				<path
					opacity="0.32"
					d="M15.5778 4.47866C14.4262 2.17562 13.8505 1.02411 13.0714 0.654587C12.3933 0.33302 11.6067 0.33302 10.9287 0.654587C10.1496 1.02411 9.57386 2.17562 8.42234 4.47866L3.42695 14.4694C1.55385 18.2156 0.617304 20.0887 0.931059 21.0609C1.20188 21.9001 1.89475 22.5345 2.75447 22.7305C3.75046 22.9576 5.53399 21.86 9.10105 19.6649L9.90366 19.171C10.6648 18.7026 11.0454 18.4684 11.4529 18.377C11.8132 18.2962 12.1869 18.2962 12.5472 18.377C12.9547 18.4684 13.3353 18.7026 14.0964 19.171L14.899 19.6649C18.4661 21.86 20.2496 22.9576 21.2456 22.7305C22.1053 22.5345 22.7982 21.9001 23.069 21.0609C23.3828 20.0887 22.4462 18.2156 20.5732 14.4694L15.5778 4.47866Z"
					fill="currentColor"
				/>
				<path
					d="M12 18.316V0.413086C12.3661 0.413086 12.7323 0.493469 13.0714 0.654266C13.8505 1.02377 14.4262 2.17529 15.5778 4.47833L20.5732 14.4691C22.4463 18.2153 23.3828 20.0884 23.069 21.0606C22.7982 21.8997 22.1053 22.5341 21.2456 22.7302C20.2497 22.9573 18.4662 21.8598 14.8993 19.6648L14.0964 19.1707C13.3353 18.7023 12.9547 18.468 12.5472 18.3766C12.3671 18.3362 12.1835 18.316 12 18.316Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1790">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
